import react from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumen from "./ModalResumen";
import { formatFecha } from "../../../resources/Helper";

function ModalPlantillas(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    
    const [contenido, setContenido] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    let history = useHistory();
    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/perfil', config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombreProfesional(response.data.name+' '+response.data.lastname);
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/otras-plantillas', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            })
        
    },[]);


    const cargaritems = () => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: paciente_id
            }
        }

        axios.get('/plantillas', config2)
            .then(response => {
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    let segmentoTitulo = "<h3 class='ttl-resumen-evolucion'>Plantilla:</h3>";
                    let segmentoFecha = "<label>Fecha:</label><br />"+item.fecha;
                    let segmentoContenido = "";
                    let segmentoProfesional =   "<div style='border-top:1px dashed #c8c8c8; margin-bottom:12px;'></div>"+
                                                "<div class='row'>"+
                                                    "<div class='col-md-3'>"+
                                                        "<div class='form-group'>"+
                                                            "<label>Profesional que atendió</label>"+
                                                            item.profesional+
                                                        "</div>"+
                                                    "</div>"+
                                                    "<div class='col-md-3'>"+
                                                        "<div class='form-group'>"+
                                                            "<label>Registro médico</label><br />"+
                                                            item.registro_medico+
                                                        "</div>"+
                                                    "</div>"+
                                                    "<div class='col-md-3'>"+
                                                        "<div class='form-group'>"+
                                                            "<label>Código de habilitación</label><br />"+
                                                            item.codigo_habilitacion+
                                                        "</div>"+
                                                    "</div>"+
                                                    "<div class='col-md-3'>"+
                                                        "<div class='form-group'>"+
                                                            "<label>Firma</label>"+
                                                            "<img src='"+item.firma+"' class='firma-profesional-hc' />"+
                                                        "</div>"+
                                                    "</div>"+
                                                "</div>";

                    segmentoContenido = item.contenido ? "<br /><label>Descripción:</label><br />"+item.contenido : "";

                    const itemParcial = segmentoTitulo+segmentoFecha+segmentoContenido+segmentoProfesional+"<hr></hr>";

                    consolidadoItems+=itemParcial;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log(error);
            })
    }



    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
    }
    



    const handleSubmit = (e) => {
        
        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            paciente_id: pacienteId,
            client_id: client.client_id,
            profesional: nombreProfesional, 
            firma: firmaimg, 
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido
        }
        
        axios.post('/plantilla',config)
            .then(response => {
                setLoading(false);
                props.cerrarModal();
                props.guardarCambios('La plantilla ha sido agregada');
                cargaritems();
            })
            .catch(error => {
                console.log(error.response.data);
                setErrorlist(error.response.data.errors);
            })
            
    }


    const verResumen = (ttlResumen,resumenIndividual) => {
        setTituloResumen(ttlResumen);
        
        const contenidoResumen = "<label>Fecha:</label><br />"+
                                        resumenIndividual.fecha+
                                        "<br /><label>Contenido:</label><br />"+
                                        resumenIndividual.contenido;

        setContenidoResumenIndividual(contenidoResumen);
        setProfesionalResumenIndividual(resumenIndividual.profesional);
        setRegistroMedicoResumenIndividual(resumenIndividual.registro_medico);
        setCodigoHabilitacionResumenIndividual(resumenIndividual.codigo_habilitacion);
        setFirmaResumenIndividual(resumenIndividual.firma);
    }


    useEffect(() => {
        cargaritems();
    },[props.cargarHistorial]);


    if (loggedIn) {
        return (
            
                
                <>
                    <section className="content">
                        <div className="container-fluid">

                                <div className="row">
                                    <div className="col-md-9">

                                        <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                            <div id="historiageneral">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label style={{fontSize:'1rem',marginBottom:'8px'}}>Seleccione la plantilla o digite su contenido</label>
                                                        

                                                        <div className="form-group">
                                                            <select name="plantillas" className="form-control" id="plantillas" onChange={(e) => setContenido(e.target.value)} >
                                                                <option></option>
                                                                {
                                                                    plantillas.map((plantilla) => 
                                                                        <option value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                        </div>
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.contenido}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div id="profesional-atiende">
                                                    <div className="card-body" style={{padding: '0.7rem'}}>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                                    <br></br>
                                                                    {nombreProfesional}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="nombreProfesional">Registro médico</label>
                                                                    <br></br>
                                                                    {registroMedico}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                                    <br></br>
                                                                    {codigoHabilitacion}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                    <label htmlFor="nombreProfesional">Firma</label>
                                                                    <br></br>
                                                                    <img src={firmaimg} className="firma-profesional-hc" />
                                                                </div>
                                                            </div>  
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-primary">
                                                        Guardar&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>

                                        </form>
                                    
                                    </div>
                                    <div className="col-md-3">
                                        
                                        <div className="timeline-evolucion">

                                            <b className="titulo-historial">Historial de plantillas</b>

                                            {
                                                historial.map((item) => 
                                                    
                                                        <div className="timeline-item-container" data-toggle="modal" data-target="#modalResumenPlantillas" onClick={() => verResumen('Plantilla',item)}>
                                                            <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                            <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                                        </div>
                                                    )
                                            }

                                        </div>
                                        
                                        <button className="btn btn-primary btn-resumen-historico" data-toggle="modal" data-target="#modalConsolidadoPlantillas">Ver todo</button>
                                    
                                    </div>
                                </div>
                            
                            </div>
                        </section>
                    

                <ModalResumen 
                                    idModal="modalResumenPlantillas"
                                    titulo={tituloResumen} 
                                    contenido={contenidoResumenIndividual} 
                                    profesional={profesionalResumenIndividual} 
                                    registro={registroMedicoResumenIndividual} 
                                    codigo={codigoHabilitacionResumenIndividual} 
                                    firma={firmaResumenIndividual} />

                <ModalResumen 
                                idModal="modalConsolidadoPlantillas"
                                titulo="Resumen plantillas" 
                                contenido={consolidado} />
                </>
                
            
        );
    }

    return (
        <Loading />
    );
}
export default ModalPlantillas;